module.exports = __webpack_public_path__ + "static/media/reply-all.5e43931a.svg";